import { rangoFechaDefecto } from './state'

export default {
  SET_LOADING: (state, val) => { state.loading = val },
  SET_ITEMS: (state, data) => {
    state.items = data?.data ?? data ?? []
    if (data?.total !== undefined) {
      state.pagination = {
        page: data.current_page ?? 1,
        perPage: data.per_page ?? 20,
        total: data.total ?? 0,
        lastPage: data.last_page ?? 1
      }
    }
  },
  SET_VISTA: (state, vista) => { state.vista = vista },
  SET_FILTRO: (state, { campo, valor }) => { state.filtros[campo] = valor },
  RESET_FILTROS: (state) => {
    state.filtros = {
      area: null, estado: null, prioridad: null, responsable_id: null,
      solicitante_id: null, cliente_id: null, ticket_id: null, cotizacion_id: null, search: '',
      ...rangoFechaDefecto(), solo_vencidas: false, archivado: false
    }
  },

  SET_DETALLE_LOADING: (state, val) => { state.detalleLoading = val },
  SET_DETALLE: (state, ot) => { state.detalle = ot },
  CLEAR_DETALLE: (state) => { state.detalle = null },

  PATCH_ITEM_IN_LIST: (state, ot) => {
    const idx = state.items.findIndex((i) => i.id === ot.id)

    if (idx !== -1) state.items.splice(idx, 1, { ...state.items[idx], ...ot })
  },

  SET_USUARIOS_ASIGNABLES: (state, usuarios) => { state.usuariosAsignables = usuarios },

  SET_AREAS: (state, areas) => { state.areas = areas },

  SET_CHECKLIST_PLANTILLAS: (state, plantillas) => { state.checklistPlantillas = plantillas },
  ADD_CHECKLIST_PLANTILLA: (state, plantilla) => { state.checklistPlantillas.push(plantilla) },
  PATCH_CHECKLIST_PLANTILLA: (state, plantilla) => {
    const idx = state.checklistPlantillas.findIndex((p) => p.id === plantilla.id)

    if (idx !== -1) state.checklistPlantillas.splice(idx, 1, plantilla)
  },
  REMOVE_CHECKLIST_PLANTILLA: (state, id) => {
    state.checklistPlantillas = state.checklistPlantillas.filter((p) => p.id !== id)
  }
}
